/* global $, Expats */
/* exported ExpatsJob */
const ExpatsJob = function () {

    const saveApplicationCallback = (r) => {
        if (r.status === 'ok') {
            $('#job-offer .container.form div').html(r.success_msg);

            if ($(window).innerWidth() < 1024) {
                Expats.scrollToElement('#application-sent', 80);
            }
        } else if (r.status === 'nok') {
            Expats.showPopup(r.error, { type: 'warning'});
        }
    };

    const saveExternalApplicationCallback = (r) => {
        if (r.status === 'ok') {
            $('#job-offer .container.form div').html(r.success_msg);

            window.open(r.redirect_url, '_blank');
        }  else if (r.status === 'nok') {
            Expats.showPopup(r.error, { type: 'warning' });
        }
    };

    return {
        saveApplicationCallback: saveApplicationCallback,
        saveExternalApplicationCallback: saveExternalApplicationCallback
    };
}();